import { defaultFont, hexToRgb } from "assets/jss/material-dashboard-react.js";

// const width_proportion = "80%";
const dialogStyle = (theme) => ({
  root: {
    flexGrow: 1,
  },
  control: {
    padding: theme.spacing(2),
  },
  dialog: {
    backgroundColor: "#ECECEC",
    ...defaultFont,
  },
  text: {
    color: "rgba(" + hexToRgb("#252536") + ", 0.8)",
    fontWeight: 400,
  },
  input: {
    color: "black",
  },
  button: {
    backgroundColor: "rgba(" + hexToRgb("#434359") + ", 0.3)",
    margin: 5,
    whiteSpace: "pre-wrap",
    textTransform: "lowercase",
    "&:hover": {
      backgroundColor: "rgba(" + hexToRgb("#434359") + ", 0.6)",
    },
  },
});

export default dialogStyle;
